
import Scrollbar from '../../../../resources/scripts/vendor/splide/scrollbar';
import { breakpoints } from '../../../../resources/scripts/vendor/tailwind';

document.addEventListener('alpine:init', () => {
  const pagination = document.querySelector('.pagination-history');
  window.Alpine.data('historySlider', (amountOfSlides, perPage = 1) => ({
    init () {
      new window.Splide(this.$el, {
        'type': 'slide',
        'arrows': true,
        'gap': '40px',
        'autoHeight': true,
        scrollbar: amountOfSlides > perPage,
        breakpoints: {
          [breakpoints.md]: {
            destroy: false,
            drag: false,
            scrollbar: true,
          },
        },
      })
        .on('pagination:mounted', function (data) {
          const labels = eval(data.list.dataset.labels);
          data.list.classList.add('splide__pagination--history');

          data.items.forEach(function (item) {
            item.button.classList.add('pagination-item');
            if(labels){
              item.button.textContent = labels[item.page];
            }

          });
        })

        .on('active', () => {
          const paginationContainer = pagination.getBoundingClientRect();
          const offsetPaginationContainer = paginationContainer.x;
          const paginationElements = [...pagination.children];

          const activePaginationElement = paginationElements.find(paginationElement => {
            const button = paginationElement.querySelector('button');
            return button.classList.contains('is-active');
          });

          if (! activePaginationElement) {
            return;
          }

          const offsetElement = activePaginationElement.getBoundingClientRect();
          const offsetElementX = offsetElement.right;
          const paginationWidth = offsetElementX - offsetPaginationContainer;
          const offset = paginationWidth - paginationContainer.width;
          const scroll = pagination.scrollLeft + offset;

          pagination.scrollTo({
            left: scroll,
            behavior: 'smooth',
          });
        })
        .mount({ Scrollbar });
    }
  }));

  window.Alpine.data('historySliderMobile', () => ({
    init () {
      new window.Splide(this.$el, {
        'type': 'slide',
        'arrows': false,
        'gap': '40px',
        scrollbar: false,
        breakpoints: {
          [breakpoints.md]: {
            destroy: false,
            'arrows': false,
            scrollbar: false,
            padding: { right: 80 },
            perPage: 1,
          },
        },
      })
      .mount();
    }
  }));
});
